import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Pages/AuthLayout.vue";

const Login = () => import("@/pages/Pages/Login.vue");
const Home = () => import("@/pages/Home.vue");

const Abonos = () => import("@/pages/Abonos.vue");
const AssinaturasPonto = () => import("@/pages/AssinaturasPonto.vue");
const AbonosInserir = () => import("@/pages/AbonosInserir.vue");
const Holerite = () => import("@/pages/Holerite.vue");

const RegistrarPontoColaborador = () =>
  import("@/pages/RegistrarPontoColaborador.vue");
const RegistrarPonto = () => import("@/pages/RegistrarPonto.vue");
const RegistrarPontoEmpresas = () =>
  import("@/pages/RegistrarPontoEmpresas.vue");

// 🔹 Página pública e independente de layouts
const VerifyEmail = () => import("@/pages/Pages/VerifyEmail.vue");

const routes = [
  // PUBLIC: verificação de e-mail
  {
    path: "/verificarEmail",
    name: "VerifyEmail",
    component: VerifyEmail,
    meta: { public: true, levelAccess: 0 },
  },

  // Auth layout (login etc)
  {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
        meta: { public: true, levelAccess: 0 },
      },
    ],
  },

  // Rotas protegidas (dashboard)
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "abono",
        name: "Abonos",
        component: Abonos,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "holerite",
        name: "Holerite",
        component: Holerite,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "assinaturasPonto",
        name: "Assinaturas de Ponto",
        component: AssinaturasPonto,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "abono/inserir",
        name: "Inserir Abono",
        component: AbonosInserir,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "registrarPonto",
        name: "Registrar Ponto",
        component: RegistrarPonto,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "registrarPonto/colaborador",
        name: "Registrar Ponto Colaborador",
        component: RegistrarPontoColaborador,
        meta: { levelAccess: 10, public: false },
      },
      {
        path: "registrarPonto/empresa",
        name: "Registrar Ponto Empresa",
        component: RegistrarPontoEmpresas,
        meta: { levelAccess: 7, public: false },
      },
    ],
  },
];

export default routes;
